$shm_knowledge $mol_book2_catalog
	title \База знаний
	menu_title \База знаний
	param \knowledge
	knowledge_api_url \
	knowledge_api_headers *
	Help $shm_hitalama_guide_toggle
		section \knowledge
	spreads *
		guide <= Guide $shm_hitalama_guide
		documentation <= Documentation $shm_knowledge_manual
			menu_title \Документация разработчика
			kind \documentation
			api_url <= knowledge_api_url
			api_headers <= knowledge_api_headers
		instructions <= Instructions $shm_knowledge_manual
			menu_title \Инструкции для агентов
			kind \instructions
			api_url <= knowledge_api_url
			api_headers <= knowledge_api_headers
		showcase <= Showcase $shm_showcase
	Spread_default <= Guide
